export default __webpack_public_path__ + "static/media/xlpt.8be84705.png";